//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('transcarrierServiceActive', {
//        templateUrl: 'views/components/views/transcarrierServiceActive/transcarrierServiceActive.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'transcarrierServiceActiveService', 'translateService', function ($stateParams, stateService, modalService, transcarrierServiceActiveService, translateService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let transcarrierServiceActiveKeyno = $stateParams.transcarrier_service_active_keyno;
//            let deliveryMethodNo = $stateParams.deliverymethod_no;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//            	let data = await translateService.translateBatch(translations);

//            	Object.keys(translations).forEach((key) => {
//            		if (data?.[key]) translations[key] = data[key];
//            	});
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await transcarrierServiceActiveService.getEdit({
//                    transcarrier_service_active_keyno: transcarrierServiceActiveKeyno,
//                    deliverymethod_no: deliveryMethodNo
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                transcarrierServiceActiveService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
